import { useSelector } from "react-redux";

function UseUserBotList() {
  const {
    dashboard: { overallBotPerformance },
  } = useSelector((state) => state);

  const visibilityNumberBots = 4;

  const { bots_performance: botLists = [] } = overallBotPerformance;

  const activeBotsList = botLists?.filter((bot) => bot?.status === "Active");

  const activeBot = botLists?.find((bot) => bot?.status === "Active");
  const inactiveBots = botLists?.filter((bot) => bot?.status !== "Active");
  const otherCoinNum = activeBotsList?.length >= visibilityNumberBots ? 0 :activeBotsList?.length >= 1 ? visibilityNumberBots - activeBotsList?.length : visibilityNumberBots;

  // Step 1: Sort all inactive bots by creation date (newest first)
  const dateSortedBots = [...inactiveBots].sort(
    (a, b) => new Date(b.bot_creation_id) - new Date(a.bot_creation_id),
  );

  // Step 2: Take the top 2 bots by creation date
  const topTwoByDate = dateSortedBots.slice(0, 2);

  // Step 3: Sort the rest of the bots by balance_lists length
  const restSortedByBalance = dateSortedBots
    .slice(2)
    .sort(
      (a, b) =>
        (b?.balance_lists?.length || 0) - (a?.balance_lists?.length || 0),
    );

  // Combine top 2 (by date) with the rest (by balance)
  const sortedInactiveBots = [...topTwoByDate, ...restSortedByBalance];

  // Slice the bots to show based on whether there is an active bot
  const otherBots = sortedInactiveBots.slice(0, otherCoinNum);
  const moreBots = sortedInactiveBots.slice(otherCoinNum);

  return { activeBot, inactiveBots, otherCoinNum, otherBots, moreBots, activeBotNum: activeBotsList?.length, activeBots: activeBotsList, visibilityNumberBots };
}

export default UseUserBotList;
